export default (theme) => ({
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 2,
        padding: 4,
        borderRadius: 4,
        backgroundColor: theme.colors.background.utility025,
    },
    small: {
        gap: 2,
        padding: 2,
        borderRadius: 4,
        '& $segmentButton': {
            width: 28,
            height: 28,
            borderRadius: 4,
        },
    },
    medium: {
        gap: 2,
        padding: 4,
        borderRadius: 4,
        '& $segmentButton': {
            width: 34,
            height: 34,
            borderRadius: 4,
        },
    },
    large: {
        gap: 4,
        padding: 4,
        borderRadius: 6,
        '& $segmentButton': {
            width: 40,
            height: 40,
            borderRadius: 6,
        },
    },
    segmentButton: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 34,
        height: 34,
        border: 'none',
        borderRadius: 4,
        backgroundColor: 'transparent',
        cursor: 'pointer',
        transition: 'all .2s ease-in-out',
        '&:hover:not($segmentButtonSelected):not($segmentButtonDisabled)': {
            backgroundColor: theme.colors.background.utility050,
        },
        '&:focus-visible': {
            outline: `2px solid ${theme.colors.actionMajor[350]}`,
            outlineOffset: 1,
        },
    },
    segmentButtonSelected: {
        backgroundColor: theme.colors.primary.white,
    },
    segmentButtonDisabled: {
        opacity: 0.5,
        cursor: 'not-allowed',
    },
    icon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});
